import React, {useEffect, useRef, useState} from "react"

import ContactFormPro from "../../components/contact/ContactFormPro"
import "../restaurateur/restaurateur.css"
import "./partenaires.css"

// ─── Constantes ───────────────────────────────────────────

const PAGE_TITLE = "JustNow et ses partenaires billetterie"
const LOGO_URL = "https://justnow.app/logo.png"
const MAP_URL = "/"
const CONTACT_ID = "partenaires-contact"
const CONTACT_URL = `#${CONTACT_ID}`
const FONTS_ID = "resto-fonts"
const FONTS_URL = "https://fonts.googleapis.com/css2?family=Caveat:wght@500..700&family=Sofia+Sans+Extra+Condensed:wght@800&family=Sofia+Sans:wght@400..700&display=swap"

// Réglage « afficher les événements partenaires », lu par App.js et par la carte
const PARTNER_EVENTS_KEY = "showPartner"

/*
 * Bandeau « Ils nous font confiance ».
 * Les logos se déposent dans public/images/partenaires/ :
 * tant qu'un fichier manque, le nom du partenaire s'affiche à sa place.
 */
const PARTNERS = [
    {
        name: "Fnac Spectacles",
        logo: "https://www.fnacspectacles.com/obj/media/FR-eventim/fnac-spectacles/specialLogos/checkoutApp/logo-fnac-spectacles-2023.svg",
        text: "Premier acteur de la billetterie en France\u00a0: concerts, spectacles, sport et parcs de loisirs.",
    },
    {
        name: "Billet Réduc",
        logo: "https://media.licdn.com/dms/image/v2/D4E0BAQGesGRisdI9uA/company-logo_400_400/company-logo_400_400/0/1720769389250?e=1793836800&v=beta&t=XZbTqxl35nkoHUGXCNpb0yr9L8iITt2yKqv6Oao4vhI",
        text: "Théâtre, humour, concerts et sorties, avec des places à prix réduit.",
    },
]

const STEPS = [
    {
        title: "Vos événements arrivent dans JustNow",
        text: "Ils sont importés depuis votre catalogue et mis à jour automatiquement, sans saisie de votre part.",
    },
    {
        title: "Ils s’affichent là où ils se jouent",
        text: "Chaque date est placée sur la carte, à l’adresse de la salle, et proposée aux utilisateurs qui se trouvent à proximité.",
    },
    {
        title: "La réservation se fait chez vous",
        text: "Un lien sponsorisé mène directement à votre page de réservation\u00a0: la vente et la relation client restent les vôtres.",
    },
]

/*
 * Billets imprimés par la borne : un événement de chaque partenaire,
 * tel qu'il apparaît dans JustNow. Données fictives.
 * La bande sort par le bas : le dernier billet de la liste sort en premier.
 */
const DEMO_TICKETS = [
    {
        partner: "Billet Réduc",
        category: "Humour",
        deal: "\u221240\u202f%",
        title: "Le Grand Plateau du rire",
        venue: "Le Petit Théâtre",
        distance: "à 1,2\u00a0km",
        day: "Demain",
        time: "21\u00a0h",
    },
    {
        partner: "Fnac Spectacles",
        category: "Concert",
        title: "Les Nuits acoustiques",
        venue: "Théâtre de Verdure",
        distance: "à 650\u00a0m",
        day: "Ce soir",
        time: "20\u00a0h\u00a030",
    },
]

const SOCIAL_LINKS = [
    {
        name: "Facebook",
        modifier: "facebook",
        href: "https://www.facebook.com/ekrakcom-1032858806762550/?fref=ts",
        path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
    },
    {
        name: "Instagram",
        modifier: "instagram",
        href: "https://www.instagram.com/justnoweurope/",
        path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z",
    },
    {
        name: "TikTok",
        modifier: "tiktok",
        href: "https://www.tiktok.com/@justnoweurope",
        path: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
    },
    {
        name: "LinkedIn",
        modifier: "linkedin",
        href: "https://www.linkedin.com/company/justnow-europe/",
        path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
    },
]

// ─── Hooks ────────────────────────────────────────────────

/**
 * Charge les polices de la page une seule fois (balise <link> dans le <head>).
 * Mêmes polices et même identifiant que les pages restaurateurs et grands comptes.
 */
const usePageFonts = () => {
    useEffect(() => {
        if (document.getElementById(FONTS_ID)) return

        const link = document.createElement("link")
        link.id = FONTS_ID
        link.rel = "stylesheet"
        link.href = FONTS_URL
        document.head.appendChild(link)
    }, [])
}

/**
 * Titre de l'onglet, restauré en quittant la page.
 */
const usePageTitle = (title) => {
    useEffect(() => {
        const previousTitle = document.title
        document.title = title

        return () => {
            document.title = previousTitle
        }
    }, [title])
}

/**
 * Passe à true la première fois que l'élément entre dans l'écran.
 */
const useFirstVisible = (ref, threshold = 0.2) => {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const el = ref.current
        if (!el) return

        if (!("IntersectionObserver" in window)) {
            setVisible(true)
            return
        }

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setVisible(true)
                observer.disconnect()
            }
        }, {threshold})

        observer.observe(el)

        return () => observer.disconnect()
    }, [ref, threshold])

    return visible
}

// ─── Actions ──────────────────────────────────────────────

/**
 * Active l'affichage des événements partenaires avant d'ouvrir la carte.
 * Le lien recharge l'accueil : App.js relit ce réglage au démarrage.
 */
const enablePartnerEvents = () => {
    try {
        localStorage.setItem(PARTNER_EVENTS_KEY, "true")
    } catch (error) {
        // Stockage indisponible : la carte s'ouvre avec le réglage habituel
    }
}

// ─── Sous-composants ──────────────────────────────────────

const PinIcon = ({className}) => (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
            fill="currentColor"
            d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
        />
    </svg>
)

/**
 * Logo du partenaire, ou son nom tant que le fichier n'est pas en place.
 */
const PartnerLogo = ({partner}) => {
    const [missing, setMissing] = useState(false)

    if (missing) {
        return <span className="pt-partner__name">{partner.name}</span>
    }

    return (
        <img
            src={partner.logo}
            alt={partner.name}
            className="pt-partner__logo"
            onError={() => setMissing(true)}
        />
    )
}

const Ticket = ({ticket}) => (
    <div className="pt-ticket">
        <div className="pt-ticket__main">
            <div className="pt-ticket__head">
                <span className="pt-ticket__tags">
                    <span className="pt-ticket__tag">{ticket.category}</span>
                    {ticket.deal && (
                        <span className="pt-ticket__tag pt-ticket__tag--deal">{ticket.deal}</span>
                    )}
                </span>
                <span className="pt-ticket__when">
                    <span>{ticket.day}</span>
                    <strong>{ticket.time}</strong>
                </span>
            </div>
            <span className="pt-ticket__title">{ticket.title}</span>
            <span className="pt-ticket__place">
                <PinIcon className="pt-ticket__pin"/>
                <span className="pt-ticket__venue">{ticket.venue}</span>
                <strong className="pt-ticket__distance">{ticket.distance}</strong>
            </span>
        </div>
        <div className="pt-ticket__stub">
            <span className="pt-ticket__book">Réserver</span>
            <span className="pt-ticket__partner">chez {ticket.partner}</span>
            <span className="pt-ticket__sponsored">Lien sponsorisé</span>
        </div>
    </div>
)

/**
 * La borne : quand elle apparaît à l'écran, elle imprime un billet
 * de chaque partenaire, tel qu'il s'affiche dans JustNow.
 */
const TicketPrinter = () => {
    const printerRef = useRef(null)
    const printed = useFirstVisible(printerRef, 0.45)

    return (
        <figure
            ref={printerRef}
            className={`pt-printer${printed ? " pt-printer--printed" : ""}`}
        >
            <figcaption className="resto-visually-hidden">
                Exemples d’événements partenaires dans JustNow.{" "}
                {DEMO_TICKETS.map((ticket) => (
                    `${ticket.category}, ${ticket.title}, ${ticket.venue}, ${ticket.distance}, à réserver chez ${ticket.partner}.`
                )).join(" ")}
            </figcaption>

            <div className="pt-printer__head" aria-hidden="true">
                <span className="pt-printer__led"/>
            </div>

            <div className="pt-printer__out" aria-hidden="true">
                <div className="pt-printer__strip">
                    {DEMO_TICKETS.map((ticket) => (
                        <Ticket key={ticket.partner} ticket={ticket}/>
                    ))}
                </div>
            </div>
        </figure>
    )
}

const SocialStrip = () => (
    <section className="lp-social-strip" aria-label="JustNow sur les réseaux sociaux">
        <div className="lp-section-inner lp-social-inner">
            {SOCIAL_LINKS.map((link) => (
                <a
                    key={link.name}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`lp-social-link lp-social-link--${link.modifier}`}
                >
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
                        <path d={link.path}/>
                    </svg>
                    {link.name}
                </a>
            ))}
        </div>
    </section>
)

// ─── Page ─────────────────────────────────────────────────

const PartenairesPage = () => {
    usePageFonts()
    usePageTitle(PAGE_TITLE)

    return (
        <div className="resto pt">
            <header className="resto-header">
                <a href="/" className="resto-header__home">
                    <img src={LOGO_URL} alt="JustNow, accueil" className="resto-header__logo"/>
                </a>
                <a href={CONTACT_URL} className="resto-btn resto-btn--secondary resto-btn--small">
                    Devenir partenaire
                </a>
            </header>

            <main className="resto-hero">
                <p className="pt-kicker">Nos partenaires billetterie</p>

                <h1 className="resto-title pt-title">
                    <span className="resto-title__line">Ils nous font confiance</span>
                </h1>

                <ul className="pt-partners" aria-label="Nos partenaires">
                    {PARTNERS.map((partner) => (
                        <li className="pt-partner" key={partner.name}>
                            <div className="pt-partner__mark">
                                <PartnerLogo partner={partner}/>
                            </div>
                            <p className="pt-partner__text">{partner.text}</p>
                        </li>
                    ))}
                </ul>

                <div className="pt-hero__grid">
                    <div className="resto-hero__intro">
                        <p className="resto-intro">
                            Concerts, théâtre, humour, festivals{"\u00a0"}: grâce à nos partenaires,
                            les spectacles qui se jouent près de chez vous apparaissent dans JustNow,
                            avec un lien pour réserver directement sur leur site.
                        </p>
                        <a href={MAP_URL} className="resto-link" onClick={enablePartnerEvents}>
                            Voir les spectacles autour de moi
                        </a>
                    </div>

                    <TicketPrinter/>

                    <section className="resto-pro" aria-labelledby="pt-how-title">
                        <h2 id="pt-how-title" className="resto-pro__title">
                            Comment fonctionne le partenariat
                        </h2>
                        <ol className="pt-steps">
                            {STEPS.map((step) => (
                                <li key={step.title}>
                                    <span className="pt-steps__title">{step.title}</span>
                                    <span className="pt-steps__text">{step.text}</span>
                                </li>
                            ))}
                        </ol>
                        <div className="resto-pro__actions">
                            <a href={CONTACT_URL} className="resto-btn resto-btn--primary">
                                Devenir partenaire
                            </a>
                        </div>
                    </section>
                </div>
            </main>

            <section id={CONTACT_ID} className="pt-contact" aria-labelledby="pt-contact-title">
                <h2 id="pt-contact-title" className="pt-contact__title">
                    <span className="pt-contact__line">Billetterie, salle ou festival{"\u00a0"}?</span>
                    {" "}
                    <span className="pt-contact__line">Rejoignez nos partenaires</span>
                </h2>
                <p className="pt-contact__text">
                    Remplissez le formulaire{" "}
                    <span className="pt-contact__nowrap">
                        ci-dessous
                        <svg className="pt-contact__arrow" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">
                            <path
                                d="M12 4v15m0 0-6-6m6 6 6-6"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                </p>
            </section>

            <ContactFormPro/>

            <SocialStrip/>

            <footer className="resto-footer">
                <div className="resto-footer__inner">
                    <img src={LOGO_URL} alt="JustNow" className="resto-footer__logo"/>
                    <nav className="resto-footer__links" aria-label="Liens utiles">
                        <a href={CONTACT_URL}>Contact</a>
                        <a href="https://justnow.app/legal/cgv.html" target="_blank" rel="noopener noreferrer">
                            Mentions légales
                        </a>
                        <a href="https://justnow.app/legal/cgu.html" target="_blank" rel="noopener noreferrer">
                            CGU
                        </a>
                    </nav>
                    <p className="resto-footer__legal">
                        © {new Date().getFullYear()} JustNow SARL — 7B Mte du Lutetia, 06500 Menton
                    </p>
                </div>
            </footer>
        </div>
    )
}

export default PartenairesPage
